export const reportOptions = {
    datePicker: 'datePicker',
    domainSelector: 'domainSelector',
    domainTypeSelector: 'domainTypeSelector',
    exportToPdf: 'exportToPdf',
    intervalPicker: 'intervalPicker',
};

export const reportMap = {
    'domain-portfolio': {
        content: 'domainPortfolio',
        index: 2,
        label: 'Domain Portfolio',
        options: [reportOptions.datePicker],
        title: 'Domain Portfolio Overview',
        url: 'domain-portfolio',
    },
    'domain-progress': {
        content: 'domainProgress',
        index: 0,
        label: 'Domain Progress',
        options: [
            reportOptions.intervalPicker,
            reportOptions.datePicker,
            reportOptions.domainSelector,
            reportOptions.exportToPdf
        ],
        title: 'Domain Progress',
        url: 'domain-progress',
    },
    'policy-progress': {
        content: 'policyProgress',
        index: 1,
        label: 'Policy Progress',
        options: [
            reportOptions.intervalPicker,
            reportOptions.datePicker,
            reportOptions.domainTypeSelector,
            reportOptions.exportToPdf
        ],
        title: 'Policy Progress',
        url: 'policy-progress',
    },
};
